import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Location } from '@angular/common';
import { PortalLeadNode } from '@app/services/api/api.types';

@Component({
  selector: 'empty-lead',
  templateUrl: './empty-lead.component.html',
  styleUrls: ['./empty-lead.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyLeadComponent {
  @Input() lead: PortalLeadNode;
  @Input() showBack: boolean;

  private location = inject(Location);

  protected readonly cardTitle = 'We’re preparing your flight options!';
  protected readonly cardSubtitle =
    '        Hang tight—our travel experts are searching for the best flights for you, and your\n' +
    '        personalized options will appear here soon. We’ll find the best routes and fares for your\n' +
    '        trip, and you’ll be notified as soon as your options are ready.';

  goBack() {
    this.location.back();
  }
}
